import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { I18nModule } from '../../../../../core/i18n';
import { DropdownModule } from '../../../../../shared';
import { ConnectedToPermissionDropdownModule } from '../../../../../shared/components/connected-to-permission-dropdown/connected-to-permission-dropdown.module';
import { ReactiveFormCheckboxSliderModule } from '../../../../../shared/components/reactive-forms-input/reactive-form-checkbox-slider/reactive-form-checkbox-slider.module';
import { ReactiveFormInputFieldModule } from '../../../../../shared/components/reactive-forms-input/reactive-form-input-field/reactive-form-input-field.module';
import { SoldToFilterModule } from '../../../../../shared/components/sold-to-filter/sold-to-filter.module';
import { UserDetailsShipToListFilterComponent } from './user-details-ship-to-list-filter.component';

@NgModule({
  declarations: [UserDetailsShipToListFilterComponent],
  imports: [
    CommonModule,
    I18nModule,
    FormsModule,
    NzIconModule,
    ReactiveFormsModule,
    ReactiveFormInputFieldModule,
    ReactiveFormCheckboxSliderModule,
    SoldToFilterModule,
    DropdownModule,
    ConnectedToPermissionDropdownModule,
  ],
  exports: [UserDetailsShipToListFilterComponent],
})
export class UserDetailsShipToListFilterModule {}
